import React from "react";

export default function RoleTabs({
  isLoading = false,
  onSelect,
  roles,
  selectedRoleId,
}) {
  if (isLoading) {
    return (
      <div className="role-access__tabs-skeleton">
        <div className="masters-state__loader" />
        <div className="role-access__tabs-skeleton-text">Loading roles...</div>
      </div>
    );
  }

  return (
    <div className="role-access__tabs" role="tablist" aria-label="Role selector">
      {roles.map((role) => {
        const isSelected = role.id === selectedRoleId;

        return (
          <button
            key={role.id}
            aria-selected={isSelected}
            className={`role-access__tab ${
              isSelected ? "role-access__tab--active" : ""
            }`.trim()}
            onClick={() => onSelect(role)}
            role="tab"
            type="button"
          >
            <span className="role-access__tab-label">{role.label || role.key}</span>
            <span className="role-access__tab-meta">
              {(role.scope_type || "global").replace(/_/g, " ")}
            </span>
          </button>
        );
      })}
    </div>
  );
}
